import { ThunkAction } from 'redux-thunk';

// Core.
import { API } from 'core';
import { OrganizationKind, PARSAction } from 'core/models';

// Globals.
import { handleServerError } from 'globals/utils/handleServerError';

// Services.
import { ReportService } from 'services/ReportService';

// Store.
import { AppState } from 'store';
import { popToast } from 'store/toast/actions';
import { errorToastOptions } from 'store/toast/constants';

// Types.
import {
  GetReport,
  GetReportFailure,
  GetReports,
  GetReportsFailure,
  GetReportsSuccess,
  GetReportSuccess,
  GET_REPORT,
  GET_REPORTS,
  GET_REPORTS_FAILURE,
  GET_REPORTS_SUCCESS,
  GET_REPORT_FAILURE,
  GET_REPORT_SUCCESS,
} from './types';
import { OrganizationKindPowerBIJaWorkspaceId, OrganizationKindPowerBIWorkspaceId } from 'core/constants';

// action creators
export const getReportByIDAction = (): GetReport => ({
  type: GET_REPORT,
});

export const getReportByIDSuccessAction = (report: any): GetReportSuccess => ({
  type: GET_REPORT_SUCCESS,
  payload: report,
});

export const getReportByIDFailureAction = (): GetReportFailure => ({
  type: GET_REPORT_FAILURE,
});

export const getReportsByWorkspaceIdAction = (): GetReports => ({
  type: GET_REPORTS,
});

export const getReportsByWorkspaceIdFailureAction = (): GetReportsFailure => ({
  type: GET_REPORTS_FAILURE,
});

export const getReportsByWorkspaceIdSuccessAction = (reports: any): GetReportsSuccess => ({
  payload: reports,
  type: GET_REPORTS_SUCCESS,
});

export const getReportsByWorkspaceId = (
  organizationKind: OrganizationKind,
  isJa: boolean,
): ThunkAction<Promise<void>, AppState, null, PARSAction> => async (dispatch): Promise<void> => {
  const workspaceId = isJa
    ? OrganizationKindPowerBIJaWorkspaceId[organizationKind]
    : OrganizationKindPowerBIWorkspaceId[organizationKind];

  if (workspaceId) {
    dispatch(getReportsByWorkspaceIdAction());

    try {
      const reports = await ReportService.getReportsByWorkspaceId(workspaceId);
      dispatch(getReportsByWorkspaceIdSuccessAction(reports));
    } catch (error) {
      const { errorMessage } = handleServerError({ error, thunkName: 'getReportsByWorkspaceId' });
      dispatch(popToast({ ...errorToastOptions, message: <>{errorMessage || 'Error retrieving reports.'}</> }));
      dispatch(getReportsByWorkspaceIdFailureAction());
    }
  }
};

// thunk actions
export const getPowerReportById = (
  userId: string,
  reportId: string,
): ThunkAction<Promise<void>, AppState, null, PARSAction> => async (dispatch) => {
  await dispatch(getReportByIDAction());
  try {
    // TODO move this to service if we keep POC
    const route = API.ServerRoute.forAction('Reports', `${userId}/${reportId}`);
    const report = await API.get(route);
    await dispatch(getReportByIDSuccessAction(report));
  } catch (error) {
    const { errorMessage } = handleServerError({ error, thunkName: 'getPowerReportById' });
    dispatch(popToast({ ...errorToastOptions, message: <>{errorMessage || 'Error retrieving report.'}</> }));
    dispatch(getReportByIDFailureAction());
  }
};
